// @flow
import openDialog from 'javascripts/utils/open-dialog';
import LinkList from 'components/molecules/link-list/LinkList';
import type { Props } from 'components/molecules/link-list/LinkList';
import { t } from 'javascripts/utils/withTranslation';

export const dialogSelectorClass = '.js-share-dialog';

export const dialogClasses = {
  scrollInnerClassName: 'share-dialog__scroll-inner',
  contentClassName: 'share-dialog__content',
};

const dynamicComponentProps = (): Props => {
  const $meta = document.querySelector('meta[name="twitter:title"]');
  const $lead = document.querySelector('meta[name="rsm:twitterlead"]');
  let twitterTitle = encodeURIComponent(document.title);
  let twitterLead = encodeURIComponent('#BadenWürttemberg');
  if ($meta) {
    // $FlowFixMe
    twitterTitle = encodeURIComponent($meta.content);
  }

  if ($lead) {
    // $FlowFixMe
    twitterLead = encodeURIComponent($lead.content);
  }

  return {
    className: 'link-list--multi',
    multiple: true,
    headline: {
      level: 3,
      text: (t('Teilen via:'): string),
      children: (t('Teilen via:'): string), // for flow
    },
    items: [
      {
        text: 'Facebook',
        icon: 'facebook-fill',
        link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          window.location
        )}`,
        attr: {
          'data-name': 'facebook',
        },
        className: 'js-popup',
        size: 'social',
        children: 'Facebook',
        external: true,
      },
      {
        text: 'X / Twitter',
        icon: 'twitter-fill',
        link: `https://twitter.com/intent/tweet?text=${twitterLead} ${twitterTitle} ${encodeURIComponent(
          window.location
        )}&via=regierungbw`,
        attr: {
          'data-name': 'x',
        },
        className: 'js-popup',
        size: 'social',
        children: 'X / Twitter',
        external: true,
      },
      {
        text: 'Bluesky',
        icon: 'bw-bluesky-logo',
        link: `https://bsky.app/intent/compose?text=${twitterLead} ${twitterTitle} ${encodeURIComponent(
          window.location
        )}`,
        attr: {
          'data-name': 'bluesky',
        },
        className: 'js-popup',
        size: 'social',
        children: 'Bluesky',
        external: true,
      },
      {
        text: 'LinkedIn',
        icon: 'linkedin-fill',
        link: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
          window.location
        )}&title=${encodeURIComponent(
          document.title
        )} &source="Baden-Württemberg"`,
        attr: {
          'data-name': 'linkedin',
        },
        className: 'js-popup',
        size: 'social',
        children: 'LinkedIn',
        external: true,
      },
      {
        text: 'XING',
        icon: 'xing-fill',
        link: `https://www.xing.com/app/user?op=share&url=${encodeURIComponent(
          window.location
        )}`,
        attr: {
          'data-name': 'xing',
        },
        className: 'js-popup',
        size: 'social',
        children: 'XING',
        external: true,
      },
      {
        text: 'E-Mail',
        icon: 'email-fill',
        link: `mailto:?subject=${encodeURIComponent(
          document.title
        )}&body=${encodeURIComponent(window.location)}`,
        attr: {
          'data-name': 'mail',
        },
        className: 'js-popup',
        size: 'social',
        children: 'E-Mail',
        external: true,
      },
      {
        text: 'Mastodon',
        icon: 'mastodon-fill',
        attr: {
          'data-name': 'mastodon',
        },
        size: 'social',
        children: 'Mastodon',
        openInputOnClick: true,
        link: `/share?text=${twitterLead} ${twitterTitle} ${encodeURIComponent(
          window.location
        )}`,
      },
    ],
  };
};

export const componentProps: Props = dynamicComponentProps();

openDialog(dialogSelectorClass, LinkList, dialogClasses, componentProps);
